<template>
  <div class="share_page">
    <van-icon :name="
    iconColor == '2'?'static/imgs/share.png'
    :'static/imgs/share_black.png'" size="20" @click="goShare" />
    <van-popup class="vertify_popup" position="bottom" v-model="isShowPopup">
      <div class="share_title">分享到</div>
      <van-icon class="delete_icon" name="static/imgs/delete_icon.png" size="16" @click="isShowPopup = false">
      </van-icon>
      <div class="share_box clearfix">
        <div class="share_icon">
          <van-image src="static/imgs/weixin.png" width="47" @click="goShareWeiXin" />
          <div class="share_text">微信</div>
        </div>
        <div class="share_icon">
          <van-image src="static/imgs/pengyouquan.png" width="47" @click="goSharePengYouQuan" />
          <div class="share_text">朋友圈</div>
        </div>
        <div class="share_icon">
          <van-image src="static/imgs/lianjie.png" width="47" @click="copyLink" />
          <div class="share_text">复制链接</div>
        </div>
      </div>
      <div class="share_cancel" @click="isShowPopup = false">取消</div>
    </van-popup>
  </div>
</template>

<script>
import androidinfo from "@/utils/androidinfo";
export default {
  props: {
    iconColor: {
      type: String,
      default: "1"
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },//分享传递的参数 title, imageUrl, url
  },
  data () {
    return {
      isShowPopup: false,
    }
  },
  methods: {
    goShare () {
      this.isShowPopup = true
    },
    //微信交友
    goShareWeiXin () {
      this.isShowPopup = false
      androidinfo.thirdShare("Wechat", this.params.title, this.params.imageUrl, this.params.url, 4)
    },
    //朋友圈
    goSharePengYouQuan () {
      this.isShowPopup = false
      androidinfo.thirdShare("WechatMoments", this.params.title, this.params.imageUrl, this.params.url, 4)
    },
    //复制链接
    copyLink () {
      this.isShowPopup = false
      androidinfo.copyToClipboard('【' + this.params.title + '】' + this.params.url)
    }
  }
}
</script>

<style scoped>
.share_page {
  margin-top: 5px;
}
.vertify_popup {
  width: 94%;
  margin-left: 3%;
  bottom: 10px;
  border-radius: 10px;
  padding: 10px 10px 22px 10px;
  box-sizing: border-box;
  z-index: 1000000001!important;
}
.delete_icon {
  position: absolute;
  right: 10px;
  top: 10px;
}
.share_title {
  margin-top: 12px;
  font-size: 15px;
  color: #434343;
  text-align: center;
}
.share_box {
  margin-top: 27px;
  text-align: start;
}
.share_icon {
  margin-left: 22px;
  float: left;
  text-align: center;
}
.share_text {
  margin-top: 5px;
}
.share_cancel {
  width: 62%;
  height: 34px;
  line-height: 34px;
  margin: auto;
  margin-top: 28px;
  font-size: 14px;
  color: #434343;
  text-align: center;
  background-color: #eeeeee;
  border-radius: 30px;
}
/deep/.vertify_popup .van-overlay {
  z-index: 2001;
  position: fixed;
}
</style>


// WEBPACK FOOTER //
// src/components/share/index.vue